/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : order-details-api.ts
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H352615
*
* @Date         : AUG 12, 2019
*
* @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
******************************************************************************/

import { CheckoutServiceURL } from '../constants/checkout-constants';
import API from './api';
import { logError } from '../../../utils/console-utility';

class OrderDetails {
  static async getOrderSummary(userId: string, soldTo: string, shipTo: string) {
    const orderSummaryURL = `${CheckoutServiceURL.GET_CART_DETAILS_URL}${userId}/carts`;
    const response = await API.get(
      `${orderSummaryURL}?soldTo=${soldTo}&shipTo=${shipTo}`
    ).catch(error => {
      logError('Error fetching and parsing data - order details ', error);
    });
    return response ? response.data : {};
  }
}

export default OrderDetails;